// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__aITOR","container":"styles_container__1RwPQ","title":"styles_title__1WlPc","wrapper":"styles_wrapper__3S8rl","answer":"styles_answer__3r_Wx"};